import { Loading } from 'components/loading/Loading';
import { tableStyles } from 'css/tableStyles';
import { IAssignTagModal } from 'interfaces/inventory';
import React, { useState } from 'react';
import { useEffect } from 'react';
import DataTable from 'components/DataTable';
import { addInventoryItemTag,assignTagToSubscription } from 'services';
import { fetchTags } from 'services/api/tags';
import { TAG_TYPES, showError, showSuccess } from 'utils';
import styles from '../AddTagModal/index.module.scss';

const columns = [
  {
    name: 'Id',
    selector: 'objectId',
  },
  {
    name: 'Name',
    selector: 'value',
  },
  {
    name: 'English Name',
    selector: 'enValue',
  },
];

const AssignTagModal = (props: IAssignTagModal) => {
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [tags, setTags] = useState<Record<string, string>[]>([]);
  const [filterText, setFilterText] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const {
    toggleModal,
    onSuccess,
    itemId,
    assignedTags,
    tagType,
  } = props;

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    try {
      if(tagType===TAG_TYPES.SUBSCRIPTION){
        await assignTagToSubscription(itemId,selectedTags);
      }
      if(tagType===TAG_TYPES.INVENTORY_ITEM){
        await addInventoryItemTag(itemId, selectedTags);
      }
      showSuccess(`Tag added successfully`);
      onSuccess();
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllTags = async () => {
    setLoading(true);
    try {
      const response = await fetchTags();
      setTags(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const onSelectedRows = (selectedRowState) => {
    const { allSelected, selectedCount, selectedRows } = selectedRowState;
    const selectedRowTags = selectedRows.map(row => row.objectId);
    setSelectedTags(selectedRowTags);
  };

  const getTableData = () => (
    tags.filter(tag => tag.value.toLowerCase().includes(filterText.toLocaleLowerCase()))
  );

  useEffect(() => {
    fetchAllTags();
    setSelectedTags(assignedTags);
  }, [itemId]);

  return (
    <form onSubmit={handleSubmit} className={styles['main-container-tag-modal']}>
      <div className={styles['modal-container-tag-modal']}>
        <div className={styles['modal-header']}>
          <div>
            {/* <div className={styles['label']}>Add Tag</div> */}
            <div className={styles['modal-title']}>
              {tagType ?
                `Assign Tag to subscription -${itemId}` :
                `Assign Tag to inventory item -${itemId}`}
            </div>
          </div>
          <i className={'fa fa-times'} onClick={() => toggleModal()} />
        </div>
        <div className={styles['modal-body']}>
          {loading && <Loading />}
          <DataTable
            columns={columns}
            data={getTableData()}
            noHeader
            highlightOnHover={true}
            customStyles={tableStyles}
            pagination={false}
            subHeader
            subHeaderComponent={
              <input
                type={'text'}
                placeholder={'Search tag name'}
                onChange={(e) => setFilterText(e.target.value)}
                style={{ paddingLeft: '10px' }}
              />
            }
            subHeaderAlign={'left'}
            selectableRows={true}
            onSelectedRowsChange={onSelectedRows}
            selectableRowsNoSelectAll={true}
            selectableRowSelected={row => selectedTags.includes(row.objectId)}
            selectableRowDisabled={row => assignedTags.includes(row.objectId)}
            style={{ height: '144px', overflowY: 'auto' }}
          />
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={() => toggleModal()}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type={'submit'}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default AssignTagModal;